<template>
  <transition name="slide-up">
    <div v-if="showBanner" class="cookie-consent">
      <div class="cookie-consent-content">
        <div class="cookie-consent-text">
          <p>
            Данный сайт использует файлы-cookies, а также другие технологии для улучшения работы, 
            совершенствования сервисов, определения пользовательских предпочтений и обеспечения безопасности. 
            Продолжая работу с сайтом, Вы даете согласие на обработку файлов-cookies в соответствии с 
            Политикой в отношении обработки персональных данных. 
            При несогласии Вы можете отключить обработку файлов-cookies в настройках Вашего браузера или закрыть страницу сайта.
          </p>
        </div>
        <div class="cookie-consent-actions">
          <el-button type="primary" @click="acceptCookies">
            Принять
          </el-button>
          <el-button @click="rejectCookies">
            Отклонить
          </el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      showBanner: false
    }
  },
  mounted() {
    // Проверяем, было ли уже дано согласие
    const consent = localStorage.getItem('cookieConsent')
    if (!consent) {
      // Показываем баннер с небольшой задержкой для лучшего UX
      setTimeout(() => {
        this.showBanner = true
      }, 1000)
    }
  },
  methods: {
    acceptCookies() {
      // Сохраняем согласие в localStorage
      localStorage.setItem('cookieConsent', 'accepted')
      localStorage.setItem('cookieConsentDate', new Date().toISOString())
      
      // Скрываем баннер
      this.showBanner = false
    },
    rejectCookies() {
      // Сохраняем отказ в localStorage
      localStorage.setItem('cookieConsent', 'rejected')
      localStorage.setItem('cookieConsentDate', new Date().toISOString())
      
      // Скрываем баннер
      this.showBanner = false
    }
  }
}
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  padding: 20px;
  border-top: 1px solid #e4e7ed;
}

.cookie-consent-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}

.cookie-consent-text {
  flex: 1;
  min-width: 300px;
}

.cookie-consent-text p {
  margin: 0;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

.cookie-consent-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

/* Анимация появления */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-up-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-enter-to {
  transform: translateY(0);
  opacity: 1;
}

.slide-up-leave-from {
  transform: translateY(0);
  opacity: 1;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .cookie-consent-content {
    flex-direction: column;
    align-items: stretch;
  }

  .cookie-consent-actions {
    width: 100%;
    justify-content: stretch;
  }

  .cookie-consent-actions .el-button {
    flex: 1;
  }
}
</style>

